<template>
  <div v-if="loaded && this.isMobile" id="mobile_add_to_cart_wrapper" class="mobile_add_to_cart_wrapper">
    <span v-if="upstreamConnectionFailure" class="product-aside-heading-upsteam-connection-error">
      ⚠️ There is currently an issue connecting to the stock control system. Please enter your email below and we can alert you as soon as this is resolved.
    </span>
    <div v-if="isEnquireNow && !isComingSoon" class="product-aside-cart-container" data-test="enquire_now" style="position: fixed; bottom: 0; left: 0; width: 100%; min-height: 99px; height: auto; display: flex; flex-direction: column; align-items: center; padding: 20px; margin-bottom: 0; z-index: 1000;">
      <button id="enquireNowSleek" class="btn--product-aside product-aside-enquire-now">REGISTER YOUR INTEREST</button>
    </div>
    <div v-if="showProductActions">
      <outOfStock
        v-if="(isOutOfStock || isComingSoon) && product.shopify_metafields.notify_me_block && !isEnquireNow"
        :product_id="id"
        :variants="product.product_variants"
      />
      <addToCart
        v-if="showAddToCart && !isOutOfStock && !isComingSoon && !product.shopify_metafields.engraving.available && !isEnquireNow"
        :id="id"
        :available="!isOutOfStock && !isComingSoon"
        :product="product"
      />
      <addToCart
        v-if="product.shopify_metafields.engraving.available && !isComingSoon && !isEnquireNow"
        :id="id"
        :engravingProduct="product.shopify_metafields.engraving.product"
        :engravingAvailable="product.shopify_metafields.engraving.available"
        :available="!isOutOfStock && !isComingSoon"
        :product="product"
      />
    </div>
    <div v-if="showCorporateMessage">
      <p>Corporate exclusive.</p>
    </div>
    <div v-if="showB2BMessage">
      <p>Not available for corporate orders.</p>
    </div>
  </div>
</template>

<script>
import stockService from "Assets/js/components/stockService";
import globalTheme from "Assets/js/components/globalTheme";
import addToCart from "../Actions/add-to-cart.vue";
import outOfStock from "../Actions/out-of-stock.vue";
import { mapGetters } from "vuex";
import Messages from "../Messages/index.vue";
import productService from "Assets/js/components/productService";

export default {
  name: "MobileAddToCartWrapper",
  components: {
    Messages,
    addToCart,
    outOfStock
  },
  data() {
    return {
      upstreamConnectionFailure: false,
      loaded: false,
      id: null,
      product: {
        product_type: "",
        shopify_title: "",
        description: "",
        shopify_metafields: {
          coming_soon: false,
        }
      },
      isEnquireNow: false,
      isComingSoon: false,
      personalisationRequired: false,
      stockCount: 99,
      isOutOfStock: false,
      notInMarketCatalog: false,
      wishlist_enabled: false,
    };
  },
  async beforeMount() {
    this.id = this.$parent?.id ?? '';
    this.id = this.id.replace('gid://shopify/Product/', '');
    await this.fetchProduct();
    await this.stockcheck();
  },
  computed: {
    ...mapGetters(['isB2B', 'isMobile']),
    showAddToCart() {
      return !this.notInMarketCatalog && !this.isEnquireNow && !this.showOutOfStock && !this.product.shopify_metafields.engraving.available && !this.isComingSoon;
    },
    showCorporateMessage() {
      return (!this.b2cCanBuy && this.b2bCanBuy) && !this.isB2B;
    },
    showB2BMessage() {
      return this.isB2B && this.b2cCanBuy && !this.b2bCanBuy;
    },
    showProductActions() {
      if (this.notInMarketCatalog) {
        return false;
      }
      return  (!this.isB2B && this.b2cCanBuy) || (this.isB2B && this.b2bCanBuy) && !this.showB2BMessage;
    },
  },
  methods: {
    stockcheck(){
      this.stockService = stockService.getInstance();
      this.stockService.checkStock(
        'gid://shopify/Product/' + this.id,
        (responseData) => {
          this.upstreamConnectionFailure = false;
          this.notInMarketCatalog = false;
          this.isOutOfStock = !responseData?.availableForSale;
          this.stockCount = responseData?.totalInventory ?? 99;
          if(responseData?.availableForSale && responseData?.totalInventory <= 0 ){
            this.stockCount = 99;
          }
        },
        (error) => {
          this.loaded = true;
          this.upstreamConnectionFailure = true;
        },
        () => {
          // Not in this market's catalog: Shopify would refuse it at checkout.
          this.notInMarketCatalog = true;
          this.upstreamConnectionFailure = false;
          this.loaded = true;
        }
      );
      this.loaded = true;
    },

    async fetchProduct() {
      this.productService = productService.getInstance();
      this.product = await new Promise((resolve) => {
        this.productService.checkProduct(
          'gid://shopify/Product/' + this.id,
          globalTheme.localCode(),
          (product) => resolve(product)
        );
      });

      this.isComingSoon = this.product?.shopify_metafields?.coming_soon;
      this.isEnquireNow = this.product?.shopify_metafields?.enquire_now;
      this.personalisationRequired = this.product?.shopify_metafields?.requires_personalisation;
    },
    price_class() {
      if (this.isOutOfStock && !this.product.shopify_metafields?.coming_soon) {
        return "product-aside-price product-aside-price--outofstock";
      } else {
        return "product-aside-price";
      }
    },
    price_exvat_class() {
      if (this.isOutOfStock && !this.product.shopify_metafields?.coming_soon) {
        return "product-aside-price-exvat product-aside-price-exvat--outofstock";
      } else {
        return "product-aside-price-exvat product-aside-price-exvat";
      }
    },
  },
}
</script>
